import { globalState } from '@codeleap/store'

import { reduce } from '@/features/Auth/machine/reduce'
import { AuthEvent, AuthState, anonymous } from '@/features/Auth/machine/states'

/**
 * Where signing in currently is, shared by every screen that renders part of it.
 *
 * The union is nested under a key on purpose: `globalState.set` merges into the current
 * value, so setting the union directly would leave fields behind from the variant it
 * replaced — a `completing` state's `missing` surviving into `ready`, for instance.
 */
const store = globalState<{ auth: AuthState }>({ auth: anonymous })

export const authStore = {
  use: () => store.use(state => state.auth),
  get: () => store.get().auth,

  /** The only way the state changes. Every transition goes through the machine. */
  dispatch: (event: AuthEvent) => {
    const from = store.get().auth
    const to = reduce(from, event)

    // Every transition, logged in one place. Where signing in stopped is the whole diagnosis,
    // and before this it could only be inferred from which screen someone was stranded on.
    logger.info(
      `auth: ${from.status} --${event.type}--> ${to.status}${to === from ? ' (ignored)' : ''}`,
      { from, event, to },
      'Auth'
    )

    store.set({ auth: to })
  },

  reset: () => store.set({ auth: anonymous })
}
